import { ListItem } from 'components/List'
import { addDays } from 'date-fns'
import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { SiteLanguage } from '../../../data/models/locale'
import { AppState } from '../../../data/state'
import { DateFormatType, format, getFormat } from '../../../utils/date'

interface DepartureDateProps {
  departureDate: Date | null
  days: number
  language: SiteLanguage
}

const DepartureDateSummary: React.FC<DepartureDateProps> = props => {
  const departureDate = new Date(props.departureDate || new Date())
  const toDate = addDays(departureDate, props.days - 1)
  let fromFormat = getFormat(DateFormatType.day)
  if (toDate.getMonth() !== departureDate.getMonth()) {
    fromFormat = getFormat(DateFormatType.daymonthShort)
  }

  const toFormat = getFormat(DateFormatType.date)

  return (
    <ListItem>
      <DisplayContent
        addNode
        contentKey="date-from-to"
        vars={{
          from: format(departureDate, fromFormat),
          to: format(toDate, toFormat),
        }}
      >
        {`${format(departureDate, fromFormat)} to ${format(toDate, toFormat)}`}
      </DisplayContent>
    </ListItem>
  )
}

export default connect((state: AppState) => ({
  departureDate: state.funnelOrder.departureDate,
  days: state.funnelOrder.days,
  language: state.locale.language,
}))(DepartureDateSummary)
